import "./searchbar.styles.scss";
import { useGlobalSearch } from "../../api/queries/destinationQueries";

const SearchBar = () => {
    const { searchTerm, setSearchTerm, searchEvents } = useGlobalSearch()

    const handleSubmit = (e) => {
        e.preventDefault();
        searchEvents();
    };

    return (
        <>
            <form className="form" onSubmit={handleSubmit}>
                <div className="form__search">
                    <input 
                        type="text"
                        className="form__search-input"
                        placeholder="Search for your next adventure"
                        id="search"
                        autoComplete="off"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    ></input>
                    <button
                        type="submit"
                        className="form__search-btn"
                    >
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                </div>
            </form>
        </>
    )
}

export default SearchBar;